import { CircularProgress, Container } from "@mui/material";

export const Loading = () => {
    return (
        <Container variant='center-all'>
            <CircularProgress size='5rem' />
        </Container>
    )
}